// @file locales for locale_selector.vue
interface Locale {
  standard: string
  domain: string
  html: string
  yml: string
  po: string
  rtl: boolean
  time: string
  available: boolean
  name: string
}

const allLocales: Locale[] = [
  {
    standard: 'ar',
    domain: 'ar',
    html: 'ar',
    yml: 'ar',
    po: 'ar',
    rtl: true,
    time: 'long',
    available: true,
    name: 'العربية',
  }, //Arabic
  {
    standard: 'bg',
    domain: 'bg',
    html: 'bg',
    yml: 'bg',
    po: 'bg',
    rtl: false,
    time: 'long',
    available: true,
    name: 'български',
  }, //Bulgarian
  {
    standard: 'ca',
    domain: 'ca',
    html: 'ca',
    yml: 'ca',
    po: 'ca',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Català',
  }, //Catalan
  {
    standard: 'cs',
    domain: 'cs',
    html: 'cs',
    yml: 'cs',
    po: 'cs',
    rtl: false,
    time: '%d. %B %Y %H:%M',
    available: true,
    name: 'Čeština',
  }, //Czech
  {
    standard: 'cy_GB',
    domain: 'cy-gb',
    html: 'cy-GB',
    yml: 'cy-GB',
    po: 'cy_GB',
    rtl: false,
    time: '%d %b %Y %H:%M',
    available: true,
    name: 'Cymraeg',
  }, //Welsh
  {
    standard: 'da',
    domain: 'da',
    html: 'da',
    yml: 'da',
    po: 'da',
    rtl: false,
    time: 'short',
    available: true,
    name: 'Dansk',
  }, //Danish
  {
    standard: 'de',
    domain: 'de',
    html: 'de',
    yml: 'de',
    po: 'de',
    rtl: false,
    time: '%d. %B %Y, %H:%M Uhr',
    available: true,
    name: 'Deutsch',
  }, //German
  {
    standard: 'el',
    domain: 'el',
    html: 'el',
    yml: 'el',
    po: 'el',
    rtl: false,
    time: '%d %b %Y %H:%M',
    available: true,
    name: 'Ελληνικά',
  }, //Greek
  {
    standard: 'en',
    domain: '',
    html: 'en',
    yml: 'en',
    po: 'en',
    rtl: false,
    time: '%b %d, %Y %I:%M%P',
    available: true,
    name: 'English (US)',
  }, //English
  {
    standard: 'en_GB',
    domain: 'en-gb',
    html: 'en-GB',
    yml: 'en-GB',
    po: 'en_GB',
    rtl: false,
    time: '%b %d, %Y %I:%M%P',
    available: true,
    name: 'English (UK)',
  }, //English
  {
    standard: 'es',
    domain: 'es',
    html: 'es',
    yml: 'es',
    po: 'es',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Español',
  }, //Spanish
  {
    standard: 'et',
    domain: 'et',
    html: 'et',
    yml: 'et',
    po: 'et',
    rtl: false,
    time: 'short',
    available: true,
    name: 'Eesti keel',
  }, //Estonian
  {
    standard: 'fa',
    domain: 'fa',
    html: 'fa',
    yml: 'fa',
    po: 'fa',
    rtl: true,
    time: 'long',
    available: true,
    name: 'فارسی',
  }, //Persian
  {
    standard: 'fi',
    domain: 'fi',
    html: 'fi',
    yml: 'fi',
    po: 'fi',
    rtl: false,
    time: '%e.%m.%Y %H.%M',
    available: true,
    name: 'Suomi',
  }, //Finnish
  {
    standard: 'fil',
    domain: 'fil',
    html: 'tl',
    yml: 'tl',
    po: 'tl',
    rtl: false,
    time: '%d ng %b ng %Y %H:%M',
    available: true,
    name: 'Filipino',
  }, //Tagalog
  {
    standard: 'fr',
    domain: 'fr',
    html: 'fr',
    yml: 'fr',
    po: 'fr',
    rtl: false,
    time: '%d %B %Y %Hh%M',
    available: true,
    name: 'Français',
  }, //French
  {
    standard: 'gl_ES',
    domain: 'gl-es',
    html: 'gl-ES',
    yml: 'gl-ES',
    po: 'gl_ES',
    rtl: false,
    time: '%e/%m/%y, %H:%M',
    available: true,
    name: 'Galego',
  }, //Galician
  {
    standard: 'he',
    domain: 'he',
    html: 'he',
    yml: 'he',
    po: 'he',
    rtl: true,
    time: '%d %b %Y %H:%M',
    available: true,
    name: 'עברית',
  }, //Hebrew
  {
    standard: 'hi',
    domain: 'hi',
    html: 'hi',
    yml: 'hi',
    po: 'hi',
    rtl: false,
    time: 'short',
    available: true,
    name: 'हिन्दी',
  }, //Hindi
  {
    standard: 'hr',
    domain: 'hr',
    html: 'hr',
    yml: 'hr',
    po: 'hr',
    rtl: false,
    time: 'short',
    available: true,
    name: 'Hrvatski',
  }, //Croatian
  {
    standard: 'hu',
    domain: 'hu',
    html: 'hu',
    yml: 'hu',
    po: 'hu',
    rtl: false,
    time: '%Y. %B %e., %H:%M',
    available: true,
    name: 'Magyar',
  }, //Hungarian
  {
    standard: 'id',
    domain: 'id',
    html: 'id',
    yml: 'id',
    po: 'id',
    rtl: false,
    time: '%d %B %Y %H.%M',
    available: true,
    name: 'Bahasa Indonesia',
  }, //Indonesian
  {
    standard: 'it',
    domain: 'it',
    html: 'it',
    yml: 'it',
    po: 'it',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Italiano',
  }, //Italian
  {
    standard: 'ja',
    domain: 'ja',
    html: 'ja',
    yml: 'ja',
    po: 'ja',
    rtl: false,
    time: 'short',
    available: true,
    name: '日本語',
  }, //Japanese
  {
    standard: 'ko',
    domain: 'ko',
    html: 'ko',
    yml: 'ko',
    po: 'ko',
    rtl: false,
    time: 'short',
    available: true,
    name: '한국어',
  }, //Korean
  {
    standard: 'lv',
    domain: 'lv',
    html: 'lv',
    yml: 'lv',
    po: 'lv',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Latviešu',
  }, //Latvian
  {
    standard: 'ms',
    domain: 'ms',
    html: 'ms',
    yml: 'ms',
    po: 'ms',
    rtl: false,
    time: '%d %b %Y %H:%M',
    available: true,
    name: 'Bahasa Melayu',
  }, //Malay
  {
    standard: 'nl',
    domain: 'nl',
    html: 'nl',
    yml: 'nl',
    po: 'nl',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Nederlands',
  }, //Dutch
  {
    standard: 'no',
    domain: 'no',
    html: 'no',
    yml: 'no',
    po: 'no',
    rtl: false,
    time: '%e. %B %Y, %H:%M',
    available: true,
    name: 'Norsk',
  }, //Norwegian
  {
    standard: 'pl',
    domain: 'pl',
    html: 'pl',
    yml: 'pl',
    po: 'pl',
    rtl: false,
    time: '%d %b %Y %H:%M',
    available: true,
    name: 'Polski',
  }, //Polish
  {
    standard: 'pt_BR',
    domain: 'pt-br',
    html: 'pt-BR',
    yml: 'pt-BR',
    po: 'pt_BR',
    rtl: false,
    time: '%d/%m/%y, %H:%M hs',
    available: true,
    name: 'Português',
  }, //Portuguese
  {
    standard: 'ro',
    domain: 'ro',
    html: 'ro',
    yml: 'ro',
    po: 'ro',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Română',
  }, //Romanian
  {
    standard: 'ru',
    domain: 'ru',
    html: 'ru',
    yml: 'ru',
    po: 'ru',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Pусский',
  }, //Russian
  {
    standard: 'sk',
    domain: 'sk',
    html: 'sk',
    yml: 'sk',
    po: 'sk',
    rtl: false,
    time: '%d.%m.%y %H:%M',
    available: true,
    name: 'Slovenčina',
  }, //Slovak
  {
    standard: 'sr',
    domain: 'sr',
    html: 'sr',
    yml: 'sr',
    po: 'sr',
    rtl: false,
    time: '%d %b %Y %H:%M',
    available: true,
    name: 'српски',
  }, //Serbian
  {
    standard: 'sv',
    domain: 'sv',
    html: 'sv',
    yml: 'sv',
    po: 'sv',
    rtl: false,
    time: '%e %b %Y %H:%M',
    available: true,
    name: 'Svenska',
  }, //Swedish
  {
    standard: 'th',
    domain: 'th',
    html: 'th',
    yml: 'th',
    po: 'th',
    rtl: false,
    time: 'long',
    available: true,
    name: 'ภาษาไทย',
  }, //Thai
  {
    standard: 'tr',
    domain: 'tr',
    html: 'tr',
    yml: 'tr',
    po: 'tr',
    rtl: false,
    time: '%e %b %Y, %H:%M',
    available: true,
    name: 'Türkçe',
  }, //Turkish
  {
    standard: 'uk',
    domain: 'uk',
    html: 'uk',
    yml: 'uk',
    po: 'uk',
    rtl: false,
    time: 'long',
    available: true,
    name: 'українська мова',
  }, //Ukranian
  {
    standard: 'vi',
    domain: 'vi',
    html: 'vi',
    yml: 'vi',
    po: 'vi',
    rtl: false,
    time: 'long',
    available: true,
    name: 'Tiếng Việt',
  }, //Vietnamese
  {
    standard: 'zh_CN',
    domain: 'zh-cn',
    html: 'zh-CN',
    yml: 'zh-CN',
    po: 'zh_CN',
    rtl: false,
    time: 'long',
    available: true,
    name: '中文',
  }, //Chinese
  {
    standard: 'zh_TW',
    domain: 'zh-TW',
    html: 'zh-TW',
    yml: 'zh-TW',
    po: 'zh_TW',
    rtl: false,
    time: 'long',
    available: true,
    name: '繁體中文',
  }, //Traditional Chinese
]

const availableLocales = allLocales.filter((x: Locale): boolean => x.available)

export { availableLocales }
